import request from "@/util/http";
// import {
// baseURL
// } from '@/config/config.js'
/**
 * All rights reserved, Designed By www.covebuy.cn
 * 注意：
 * 本软件为www.covebuy.cn开发研制，未经购买不得使用
 * 购买后可获得全部源代码（禁止转卖、分享、上传到码云、github等开源平台）
 * 一经发现盗用、分享等行为，将追究法律责任，后果自负
 */
/**
 * 登录页面
 */


// 多语言load
export function load(query) {
	return request({
		url: '/upms/i18n/load',
		method: 'get',
		params: query,
	})
}

// 多语言切换
 export function message(query) {
	//  let params = query;
	//  let paramsStr = '';
	//  if (params) {
	//  	paramsStr += "?";
	//  	for (var key in params) {
	//  		if (null != params[key] && 'null' != params[key]) {
	//  			paramsStr += "&" + key + "=" + params[key];
	//  		}
	//  	}
	//  }	 
	 
	// return new Promise((resolve, reject) => {
	// 	 uni.request({
	// 		method: 'get',
	// 		url: baseURL + '/upms/i18n/message' + paramsStr,
	// 		// header: header,
	// 		// responseType: responseType,
	// 		success: (res) => { //数据获取成功
	// 			// uni.hideLoading();	
	// 			// const status = Number(res.statusCode) || 200;
	// 			// const message = res.data.message || errorCode[status] || errorCode['default'];
	// 			resolve(res);
	// 			// return res;
	// 		},
	// 		fail: (err) => {
	// 			reject(err);
	// 		}
	// 	 })
	// })
	 
	 
	 
	 
	 
	 
	return request({
		url: '/upms/i18n/message?terminal=admin&language=zh_CN',
		method: 'get',
		params: query,
	})
}


// module.exports = {
// 	load,
// 	message,
// }
